module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('site-header'), _vm._v(" "), _c('main', {
    staticClass: "wrap",
    class: _vm.$style.fourohfour
  }, [_c('h1', [_vm._v("Page not found")]), _vm._v(" "), _c('p', [_vm._v("Something seems to have gone wrong.")]), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("← Back to the homepage")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1218a0d0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/404.vue
// module id = 112
// module chunks = 2